:host {
  display: block;
}

.spw-header-persona-item {
  position: relative;
  transition: background 0.3s;
  margin-top: 12px;

  &:before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    height: 0;
    width: 100%;
  }

  &:after {
    opacity: 0;
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -2px;
    transition: all 0.3s;
    pointer-events: none;
    border-right: 4px solid transparent;
    border-top: 7px solid var(--spw-ds-primary);
    border-left: 4px solid transparent;
  }

  @include breakpoint(lg) {
    margin-right: 24px;
    margin-top: 0;
  }

  &:not(.spw-header-persona-item--active):hover {
    @include breakpoint(lg) {
      &:before {
        height: 2px;
        background: var(--spw-colors-support-grey-grey-900);
      }
    }
  }

  ::slotted(a) {
    text-decoration: none !important;
    color: var(--spw-colors-support-grey-grey-900);
    @include breakpoint(lg) {
      display: block;
    }
  }

  &--active {
    font-weight: bold;
    ::slotted(a) {
      @include under-breakpoint(lg) {
        color: var(--spw-ds-primary) !important;
        text-decoration: none !important;
      }
    }
    @include under-breakpoint(lg) {
      display: none;
    }
    @include breakpoint(lg) {
      &:before {
        height: 2px;
        background: var(--spw-ds-primary);
      }
      &:after {
        opacity: 1;
        bottom: -11px;
      }
    }
  }
}
